<template>
  <div class="container-fluid py-4">
    <!-- Header clinique -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-tags fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Création d'un Type de Service</h2>
      </div>
      <router-link
        class="btn btn-primary btn-lg shadow-sm btn-clinique"
        :to="{ name: 'liste_type_service' }"
      >
        <i class="bi bi-arrow-left-circle me-2"></i> Retour
      </router-link>
    </div>

    <!-- Card formulaire -->
    <div class="card p-4 shadow-sm rounded card-clinique">

      <!-- Erreur générale (ex: doublon) -->
      <div v-if="globalError" class="alert alert-danger py-2 mb-3">
        {{ globalError }}
      </div>

      <div class="row g-4">
        <!-- Libellé -->
        <div class="col-md-6">
          <label for="nom" class="form-label fw-semibold">Libellé</label>
          <input
            type="text"
            id="nom"
            v-model="typeService.nom"
            class="form-control form-control-clinique"
            :class="{ 'is-invalid': error.nom }"
            placeholder="Ex : Laboratoire"
            @input="error.nom = ''; globalError = ''"
          >
          <div class="invalid-feedback">{{ error.nom }}</div>
        </div>

        <!-- Description -->
        <div class="col-md-6">
          <label for="description" class="form-label fw-semibold">Description</label>
          <textarea
            id="description"
            v-model="typeService.description"
            class="form-control form-control-clinique"
            rows="3"
            placeholder="Description (optionnel)"
          ></textarea>
        </div>
      </div>

      <!-- Statut -->
      <div class="row g-4 mt-1">
        <div class="col-md-6 d-flex align-items-center">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              id="enabled"
              v-model="typeService.isEnabled"
            >
            <label class="form-check-label ms-2 fw-semibold" for="enabled">
              Activé ?
            </label>
          </div>
        </div>
      </div>

      <!-- Boutons -->
      <div class="d-flex justify-content-end gap-3 mt-4">
        <button
          class="btn btn-light border shadow-sm px-4 py-2"
          @click="cancel"
        >
          <i class="bi bi-x-circle me-1"></i> Annuler
        </button>

        <button
          class="btn btn-success shadow px-4 py-2 btn-clinique"
          :disabled="isLoading"
          @click="saveTypeService"
        >
          <i class="bi bi-save me-1"></i>
          <span v-if="isLoading">Chargement...</span>
          <span v-else>Enregistrer</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'CreateTypeService',
  data() {
    return {
      isLoading: false,
      typeService: {
        nom: '',
        description: '',
        isEnabled: true
      },
      error: {
        nom: ''
      },
      globalError: ''
    };
  },
  methods: {
    validateForm() {
      this.error = {
        nom: this.typeService.nom.trim() ? '' : 'Le libellé est requis'
      };
      return !Object.values(this.error).some(err => err !== '');
    },

    async saveTypeService() {
      if (!this.validateForm() || this.isLoading) return;

      this.globalError = '';

      try {
        this.isLoading = true;
        const payload = {
          nom: this.typeService.nom.trim(),
          description: this.typeService.description,
          isEnabled: this.typeService.isEnabled
        };
        await api.createItem('type_services', payload);
        alert("Type de service créé avec succès !");
        this.$router.push({ name: 'liste_type_service' });
      } catch (error) {
        console.error('Erreur création type service', error);

        // Le backend renvoie 409 + message clair en cas de doublon
        if (error.response?.status === 409) {
          this.error.nom = error.response.data?.message;
          this.globalError = error.response.data?.message;
        } else {
          this.globalError = error.response?.data?.message
            || "Une erreur s'est produite lors de l'enregistrement.";
        }
      } finally {
        this.isLoading = false;
      }
    },

    cancel() {
      this.$router.push({ name: 'liste_type_service' });
    }
  }
};
</script>

<style scoped>
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}

.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}

.form-control-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 10px 14px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}

.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}
</style>